<template>
  <div id="app">
    <router-view/>
    <footer class="footer">
      <img src="./assets/footer.png" class="f_i" />
      <a href="http://beian.miit.gov.cn" style="color: black;">沪ICP备14000594号-3</a>
<!--      <a href="http://beian.miit.gov.cn" style="color: black;">沪ICP备14000594号-7</a>-->
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body{
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
a{
  color: white;
  text-decoration: none;
}
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  background: url("./assets/bg.jpg") no-repeat center center;
  background-size: cover;
}
.footer{
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: white;
  padding: 40px 0 20px 0;
  text-align: center;
}
.f_i{
  width: 100px;
  position: absolute;
  left: 50%;
  top: -47px;
  margin-left: -50px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue